import { render } from "./ProductNotAvailable.vue?vue&type=template&id=230cf958&scoped=true"
import script from "./ProductNotAvailable.vue?vue&type=script&lang=js"
export * from "./ProductNotAvailable.vue?vue&type=script&lang=js"

import "./ProductNotAvailable.vue?vue&type=style&index=0&id=230cf958&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230cf958"]])

export default __exports__